import { render, staticRenderFns } from "./msgDetails.vue?vue&type=template&id=58435d6e&scoped=true"
import script from "./msgDetails.vue?vue&type=script&lang=js"
export * from "./msgDetails.vue?vue&type=script&lang=js"
import style0 from "./msgDetails.vue?vue&type=style&index=0&id=58435d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58435d6e",
  null
  
)

export default component.exports